<div class="w-[700px]" *ngIf="!isDialog">
  <div class="app__itemCard w-full h-auto min-h-[154px] max-h-[310px] justify-start p-0 text-base">
    <div class="flex justify-between items-center p-4 border-b">
      <p class="app__text-higlight flex text-[#1E1E20] text-base m-0">
        {{ !selectedUser ? 'Global User Search' : 'Select Relationship Type' }}
        @if (data?.fromLinkedTemplate) {
        <span
          class="ml-1"
          matTooltip="Some Kinnect users might not be visible here. This is because all users have the ability to make their account invisible to other users who they are not connected to."
        >
          <img src="../../../../../../assets/images/info-icon.svg" width="16px" height="16px"
        /></span>
        }
      </p>
      <span class="material-icons search-icon text-k-black font-bold cursor-pointer" (click)="closeDialog()"> close </span>
    </div>
    <!-- <input type="text" /> -->
    <div class="p-4 relative">
      @if (selectedUser) {
      <div
        [class]="
          'flex items-center gap-2 rounded-lg px-4 p-2 border border-[#ddddd3] font-semibold text-center text-[#515765] hover:bg-light-blue cursor-pointer h-16 w-full text-xs sm:text-sm justify-between my-2 '
        "
      >
        <div class="flex gap-2 items-center">
          <ngx-avatars
            size="32"
            [src]="selectedUser?.user_profile_image_url"
            [name]="selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name"
            [round]="false"
            initialsSize="2"
            cornerRadius="100"
          ></ngx-avatars>
          <div
            class="flex items-start flex-col"
            [matTooltip]="selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name"
            matTooltipPosition="above"
          >
            <p class="m-0">{{ selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name | truncateStrPipe : 28 }}</p>
            <span class="text-k-light-grey font-medium text-xs"> {{ selectedUser?.relationship_name }} </span>
          </div>
        </div>
        <div class="flex gap-3 items-center justify-between">
          <connect-relationship-dialog
            style="margin-top: 8px"
            [hideText]="true"
            (onDatePicked)="doSomething($event)"
            [fromInvite]="true"
            [isGuardian]="false"
            subMemberPlaceHolder="How are they related to {{
              selectedUser?.user_nickname ?? selectedUser?.user_first_name + ' ' + selectedUser?.user_last_name
            }}?"
            [isConnectionModalBtn]="true"
            [isConnectionSearch]="true"
            [filterList]="data?.filterList ?? ''"
            [selectedRelationship]="selectedRelationship"
            [data]="connection_relationship_data"
            [canTruncate]="true"
          >
          </connect-relationship-dialog>
          <button class="flex items-center justify-center rounded-[50%] p-3 w-[24px] h-[24px] bg-[#FDf2f2]" (click)="clearUser()">
            <img src="/assets/images/trash-2.svg" alt="" class="w-4 h-4" />
          </button>
        </div>
      </div>
      } @else {
      <div
        [class]="
          searchResults.length < 1
            ? 'search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center'
            : ' search-wrapper p-3 rounded-lg border border-border-gray shadow-sm flex justify-between items-center rounded-b-none'
        "
      >
        <span class="material-icons search-icon text-k-blue text-base font-bold cursor-pointer"> search </span>
        <!-- <mat-icon>search</mat-icon> -->
        <input
          type="text"
          [placeholder]="data?.placeholderText ? data.placeholderText : 'Search for users by name or email'"
          class="w-full border-none outline-none text-k-grey"
          (input)="handleRelationshipSearch($event.target.value)"
          [formControl]="userInput"
        />
        @if (userInput.value) {
        <span class="material-icons search-icon text-k-grey text-base font-bold cursor-pointer" (click)="clearSearch()"> close </span>
        }
      </div>
      } @if (searchText) {
      <div class="app__itemCard w-[95.4%] left-[16px] absolute border-t-0 rounded-t-none p-0 h-auto max-h-[320px]">
        <div class="w-full h-auto max-h-[80%] overflow-y-auto" [class]="data?.fromLinkedTemplate ? 'mb-3' : ''">
          @if (!isLoading && searchResults.length > 0) { @for (user of searchResults; track user) {
          <div class="flex gap-3 items-center mb-2 hover:bg-[#EBF0FA] cursor-pointer p-4" (click)="selectUser(user)">
            <div>
              <ngx-avatars
                size="32"
                src="{{ user.user_profile_image_url }}"
                name="{{ user.user_first_name + ' ' + user.user_last_name | titlecase }}"
                initialsSize="2"
                [round]="true"
              ></ngx-avatars>
            </div>
            <div class="flex items-start gap-1 text-xs flex-col">
              <p class="m-0 font-semibold text-xs">{{ user.user_first_name + ' ' + user.user_last_name | titlecase | truncateStrPipe : 24 }}</p>
              <span class="text-[#898F9E] text-[10px] font-medium"> {{ user.user_state }} </span>
            </div>
          </div>
          } } @if (!isLoading && searchResults.length ==0) {
          <div class="flex gap-3 items-center mb-2 hover:bg-[#EBF0FA] cursor-pointer p-4">
            <div class="flex items-center gap-2 text-lg">
              <p class="m-0 text-k-blue">{{ 'No User Found' | titlecase | truncateStrPipe : 24 }}</p>
            </div>
          </div>
          } @if (isLoading){
          <div class="h-full w-full loader-option overflow-hidden">
            <div class="search-box-container w-full">
              <div class="loader-container grid grid-cols-1 p-0">
                @for (item of ['', '', '']; track item) {
                <div class="w-full h-[70px]">
                  <div class="w-full h-full" id="{{ item.id }}">
                    <div class="ph-item w-full content__loader h-full" style="padding: 0px; margin: 0px; border: none">
                      <div class="ph-col-12 h-full" style="padding: 0px !important; margin: 0px">
                        <div class="ph-row h-full">
                          <div class="ph-col-12 h-[90%]"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
          }
        </div>
        @if(!isLoading && false){
        <div class="w-full h-fit max-h-[53px] shadow-md border-t p-4">
          <div class="flex items-center gap-2 text-base">
            <p class="m-0 text-[#707070]">
              Don't see who you are looking for
              <span class="text-k-blue font-bold underline cursor-pointer" (click)="inviteUser()">invite</span> them to connect
            </p>
          </div>
        </div>
        }
      </div>
      }
    </div>

    @if (selectedUser) {
    <hr class="m-0" />
    } @if (selectedUser) {
    <div class="flex items-center gap-2 text-base justify-end p-4">
      <button
        [class]="selectedRelationshipData ? 'app__btn--primary w-fit m-0 mt-0 px-4' : 'app__btn--disabled w-fit m-0 mt-0 px-4'"
        (click)="connectUser()"
      >
        Send Request
      </button>
    </div>
    }
  </div>
</div>

@if(isDialog){
<div
  [class]="
    searchResults.length < 1
      ? 'search-wrapper px-3 h-full rounded-lg border border-border-gray shadow-sm flex justify-between items-center w-full'
      : ' search-wrapper px-3 h-full rounded-lg border border-border-gray shadow-sm flex justify-between items-center rounded-b-none w-full'
  "
>
  <span class="mt-[-2px] text-[#5475C0]"><img src="assets/images/blue-search-icon.svg" width="16px" height="16px" /></span>
  <!-- <mat-icon>search</mat-icon> -->
  <input
    type="text"
    [placeholder]="data?.placeholderText ? data.placeholderText : placeholder"
    class="w-full border-none outline-none text-k-grey ml-2"
    (input)="handleRelationshipSearch($event.target.value)"
    [formControl]="userInput"
  />
  @if (userInput.value) {
  <span class="material-icons search-icon text-k-grey text-base font-bold cursor-pointer" (click)="clearSearch()"> close </span>
  }
</div>
@if (searchText) {
<div class="app__itemCard w-full left-0 absolute border-t-0 rounded-t-none p-0 h-fit z-50">
  <div class="w-full h-fit max-h-[80%] z-50 relative">
    <div class="w-full h-auto max-h-[350px] overflow-y-auto z-50">
      @if (!isLoading && searchResults.length > 0) {
      <div class="w-full h-auto">
        @for (user of searchResults; track user) {
        <div class="flex gap-3 items-center mb-2 hover:bg-[#EBF0FA] cursor-pointer p-4" (click)="selectUser(user)">
          <div>
            <ngx-avatars
              size="32"
              src="{{ user.user_profile_image_url }}"
              name="{{ user.user_first_name + ' ' + user.user_last_name | titlecase }}"
              initialsSize="2"
              [round]="true"
            ></ngx-avatars>
          </div>
          <div class="flex items-start gap-1 text-xs flex-col">
            <p class="m-0 font-semibold text-xs">{{ user.user_first_name + ' ' + user.user_last_name | titlecase | truncateStrPipe : 24 }}</p>
            <span class="text-[#898F9E] text-[10px] font-medium"> {{ user.user_state }} </span>
          </div>
        </div>
        }
      </div>

      }
    </div>
    @if (!isLoading && searchResults.length ==0) {
    <div class="flex gap-3 items-center mb-2 hover:bg-[#EBF0FA] cursor-pointer p-4">
      <div class="flex items-center gap-2 text-lg">
        <p class="m-0 text-k-blue">{{ 'No User Found' | titlecase | truncateStrPipe : 24 }}</p>
      </div>
    </div>
    } @if (isLoading){
    <div class="h-full w-full loader-option overflow-hidden">
      <div class="search-box-container w-full">
        <div class="loader-container grid grid-cols-1 p-0">
          @for (item of ['', '', '']; track item) {
          <div class="w-full h-[70px]">
            <div class="w-full h-full" id="{{ item.id }}">
              <div class="ph-item w-full content__loader h-full" style="padding: 0px; margin: 0px; border: none">
                <div class="ph-col-12 h-full" style="padding: 0px !important; margin: 0px">
                  <div class="ph-row h-full">
                    <div class="ph-col-12 h-[90%]"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <div class="w-full h-fit shadow-md border-t p-4 bg-[#F9FAFC] rounded-b-lg">
      <div class="'grid footer-container bg-white border border-[#ddddde]">
        <mat-option class="footer-menu h-[93px]" (click)="openInvite()">
          <div class="flex-center">
            <img height="h-[33px]" src="assets/images/footer-new-user.svg" />
          </div>
          <div class="flex-center template-text mt-1">Create New User</div>
        </mat-option>
      </div>
    </div>
  </div>
  @if(!isLoading && false){
  <div class="w-full h-fit max-h-[53px] shadow-md border-t p-4">
    <div class="flex items-center gap-2 text-base">
      <p class="m-0 text-[#707070]">
        Don't see who you are looking for
        <span class="text-k-blue font-bold underline cursor-pointer" (click)="inviteUser()">invite</span> them to connect
      </p>
    </div>
  </div>
  }
</div>
}}
